module.exports = __webpack_public_path__ + "static/media/card-interligados.bcf98d69.png";